var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowwalllll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 187,
    viewBox: "0 0 221 187",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".001%",
    y1: "49.998%",
    x2: "99.991%",
    y2: "49.998%",
    id: "kobe81y57a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27AAE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F1FF",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBDED",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED4DA",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.999 107.991c20.957-13.03 12.937-28.458-22.365-21.074-56.586 11.846-100.838 39.645-95.553 49.963 7.724 9.667 30.179-7.534 38.797.119 8.619 7.652-76.409 28.407-62.178 50.192 11.117 17.015 49.044-15.795 57.142-2.37 8.098 13.426-33.237 32.159-47.515 55.677-14.277 23.519 9.998 47.602 80.33 16.28 47.586-21.192 38.826-11.411 29.86.036-6.065 7.74 12.705 27.124 42.506 4.739 30.782-23.14 60.039-52.388 36.15-44.751-36.769 11.755-23.973-11.605-8.62-27.61 15.354-16.004 46.503-36.462 14.89-50.148-13.47-5.836-49.419 15.503-49.687 4.96-.268-10.543 70.766-41.604 48.945-46.876-21.82-5.271-79.896 21.572-62.702 10.863z",
    transform: "translate(-45 -85)",
    fill: "url(#kobe81y57a)",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowwalllll);
export default __webpack_public_path__ + "static/media/showwalllll.81f18861f532bba312a1549b2d2f1dac.svg";
export { ForwardRef as ReactComponent };